import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { navigationPermissionOptions } from '@/config/navigationConfig';

interface PermissionSelectorProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export function PermissionSelector({
  value,
  onChange,
  label,
}: PermissionSelectorProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <FormControl fullWidth size="small">
      <InputLabel id="navigation-permission-label">
        {label ?? t('navigationConfig.fields.requiredPermission')}
      </InputLabel>
      <Select
        labelId="navigation-permission-label"
        value={value}
        label={label ?? t('navigationConfig.fields.requiredPermission')}
        onChange={(event) => onChange(event.target.value)}
      >
        {navigationPermissionOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {t(option.labelKey)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
